import axios from 'axios'
import store from '@/store'
import Actions from '@/constants/action'
// import { getUserInfo } from '@/util/auth'
import getConfig from '@/config/index'
import { Notify } from 'vant'

const service = axios.create({
  baseURL: getConfig().API.Base,
  timeout: 120000
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['Authorization'] = `Bearer  ${store.getters.token}`
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => response.data || response,
  error => {
    let msg = ''
    if (error && error.response && error.response.status === 400) {
      msg = `${Object.values(error.response.data).join(',')}`
    }
    if (error && error.response && error.response.status === 401) {
      return Promise.reject(store.dispatch(Actions.REFRESH_TOKEN))
      msg = `${Object.values(error.response.data).join(',')}`
    }
    const errData = (error && error.response && error.response.data || {})
    Notify({
      message: errData.resultMsg || errData.errorMessage || msg || error.message,
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
